import React, { useContext } from "react";

import OperatorTaxSetting from "app/setup/modules/operator/features/tax/tax";

import { PrivateContext } from "lib/context";
import { storageHelper } from "lib/helpers";
import { SkeletonAnnotated } from "lib/components";
import { withErrorBoundary } from "lib/hoc";

import constant from "lib/constant/constant";

const { userKey } = constant;
const { operator } = userKey;

const ManageTax = () => {
  const { isLoading } = useContext(PrivateContext);
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorTaxSetting />;
    }
    return null;
  };
  const currentUserRole = storageHelper.get("userRole");
  const TaxComponent = getComponent(currentUserRole);
  return TaxComponent;
};

export default withErrorBoundary(ManageTax);
